// extracted by mini-css-extract-plugin
export var orderSummary = "_q3-0";
export var showMoreLessButton = "_q3-1";